import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';

const ImportantNotice = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Alert className="bg-white border-2 border-amber-300 shadow-lg">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertCircle className="w-6 h-6 text-amber-700" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-slate-900 mb-3">Important Information</h3>
              <AlertDescription className="text-slate-700 text-base leading-relaxed space-y-2">
                <p>
                  <strong>AFT Senior Assisted Services provides non-medical and non-personal care support only.</strong>
                </p>
                <p>
                  We do not provide personal care such as washing, dressing, or medication administration.
                </p>
                <p>
                  Our services focus on practical help, companionship, welfare support and more, to promote independence and wellbeing.
                </p>
              </AlertDescription>
            </div>
          </div>
        </Alert>
      </div>
    </section>
  );
};

export default ImportantNotice;
